var REGEX_SECT_SCRUB = /(\.htm.*$|[\$\-\_\.\+\!\*\'\(\),\"])/gi;
/**
 * ad sect values from 1-7 which are directly based on the url
 * @param {Object} customSects
 * @public
 * @returns {Object}
 */
function generate(customSects) {
    var context = customSects || {};
    var sects = window.location.pathname.slice(1)
        .split('/');
    sects.reverse();
    sects[0] = sects[0] || 'index';
    sects = sects.slice(0, 7);

    sects.forEach(function(sect, index) {
        context['sect' + (index + 1)] = sect.replace(REGEX_SECT_SCRUB, '')
            .slice(0, 10);
    });

    // Instart Logic tracking value
    if(window['_edm_il'] === 1) {
        context['sect9'] = 'ubk';
    }

    //context = {sect1:'index',sect2:'2016',sect3:'explorer',sect4:'ford',...,sect10: 'find'};
    return context;
}

module.exports = generate;


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-context/ad-sects-generator.js
// module id = 441
// module chunks = 36